import { IconProps, iconA11yProps } from '../types';

export const RightCheck = ({ classNames, label }: IconProps) => (
    <svg className={classNames} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 34" {...iconA11yProps(label)}>
        <path d="M13.59,31.42L.59,18.42c-.78-.78-.78-2.05,0-2.83l2.83-2.83c.78-.78,2.05-.78,2.83,0l8.76,8.76L33.76,2.76c.78-.78,2.05-.78,2.83,0l2.83,2.83c.78,.78,.78,2.05,0,2.83L16.41,31.42c-.78,.78-2.05,.78-2.83,0h0Z" />
    </svg>
);
